export default "__VITE_ASSET__CqBq$y0t__"